import React from 'react';
import { motion } from 'framer-motion';

const Loader = () => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
      className="fixed inset-0 z-[9999] bg-white text-black overflow-hidden"
    >
      {/* Sliding doors */}
      <div className="absolute inset-0 flex">
        <div className="loader-door-left w-1/2 h-full bg-black" />
        <div className="loader-door-right w-1/2 h-full bg-black" />
      </div>

      {/* Expanding portal */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative w-40 h-40">
          <div className="loader-portal absolute inset-0 rounded-full border-2 border-black/30" />
          <div className="loader-portal-inner absolute inset-6 rounded-full border-2 border-black" />
          <div className="loader-portal-core absolute left-1/2 top-1/2 w-3 h-3 bg-black rounded-full -translate-x-1/2 -translate-y-1/2" />
        </div>
      </div>

      {/* Sweep line */}
      <div className="loader-sweep absolute left-0 right-0 h-px bg-black/70 top-1/2" />

      <div className="absolute bottom-16 w-full text-center">
        <div className="text-[10px] tracking-[0.5em] font-mono text-black/70">LOADING</div>
      </div>
    </motion.div>
  );
};

export default Loader;
